import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// UI_STANDARDS.md Part A: every error shows a correlation ID; a LICENSE_READ_ONLY response must
// trigger the shell's read-only-lapse banner. There is no proactive "is this org read-only?"
// endpoint (Prompt UX-01 forbids adding one), so this is detected reactively on the first write
// that actually gets blocked — a plain window event, no React import here (avoids a circular
// dependency between this module and the context that listens for it).
// BUG FIX (money correctness/freshness): any successful write anywhere in the app - a plan
// added, a payment collected, a renew/freeze/refund - must make every OTHER currently-open
// screen's dues/balance numbers correct within milliseconds, not up to the 60s default
// `staleTime` window. Rather than hunting down every mutation's `onSuccess` handler across
// dozens of files (the actual cause of members ever seeing a stale/wrong dues figure - a screen
// whose query key nobody remembered to invalidate), this fires ONE global event on every
// successful non-GET request; `index.js` listens once and invalidates the entire React Query
// cache, refetching every ACTIVE (currently rendered) query immediately. Same event-based
// pattern as the read-only-lapse/trial-cap signals below.
api.interceptors.response.use(
  (response) => {
    if ((response.config.method || "get").toLowerCase() !== "get") {
      window.dispatchEvent(new CustomEvent("fitfrik:data-changed"));
    }
    return response;
  },
  (error) => {
    const data = error.response?.data;
    if (data?.code === "LICENSE_READ_ONLY") {
      window.dispatchEvent(new CustomEvent("fitfrik:read-only-lapse"));
    }
    // UX-TRIAL §4/§5: every trial-cap 403 (members/branches/export/migration/etc, all raised by
    // `trial_engine.enforce_trial_seat_cap`/`enforce_trial_blocked`) surfaces through ONE global
    // event so the professional block modal (never a raw error) can mount once in AppShell and
    // catch every existing/future call site with zero per-screen wiring — same pattern as the
    // read-only-lapse banner above.
    if (data?.code === "TRIAL_CAP_EXCEEDED") {
      window.dispatchEvent(new CustomEvent("fitfrik:trial-cap-exceeded", { detail: { feature: data.feature, message: data.message } }));
    }
    return Promise.reject(error);
  },
);

export function formatApiError(e) {
  const data = e.response?.data;
  return {
    message: data?.message || "Something went wrong. Please try again.",
    correlationId: data?.correlation_id || null,
    code: data?.code || null,
  };
}
